import {NavList} from '@primer/react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import {getEffectiveEntryLineClass} from '../../../helpers/get-effective-entry-line-class'
import {useStackMergeabilityUpdates} from '../../../hooks/use-stack-mergeability-updates'
import {EffectiveEntryStatusLabel} from './EffectiveEntryStatusLabel'
import {EffectiveEntryStatusIcon} from './EffectiveEntryStatusIcon'
import {EffectiveEntryStatus} from '../../../helpers/effective-entry-status'

export function StackEntryNavItem({
  entry,
  previousEntry,
  tabSuffix,
  currentPullRequestId,
}: {
  entry: StackSectionStackEntry
  previousEntry?: StackSectionStackEntry
  tabSuffix: string
  currentPullRequestId: string
}) {
  const effectiveEntryStatus = entry.effectiveEntryStatus ?? EffectiveEntryStatus.NotReady

  useStackMergeabilityUpdates({basePageDataUrl: entry.pull.url, currentPullRequestId, channels: entry.channels})

  return (
    <NavList.Item
      href={`${entry.pull.url}${tabSuffix}`}
      aria-current={entry.position === 'CURRENT'}
      className={getEffectiveEntryLineClass(entry, previousEntry)}
    >
      <NavList.LeadingVisual>
        <EffectiveEntryStatusIcon status={effectiveEntryStatus} />
      </NavList.LeadingVisual>
      <span className={entry.position === 'AFTER' ? 'fgColor-muted' : ''}>{entry.pull.title}</span>
      <NavList.Description variant="block">
        <span className="fgColor-muted">
          #{entry.pull.number} · {entry.pull.headBranch}
        </span>
      </NavList.Description>
      <NavList.TrailingVisual>
        <EffectiveEntryStatusLabel status={effectiveEntryStatus} />
      </NavList.TrailingVisual>
    </NavList.Item>
  )
}
